var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-button',{staticClass:"btn-item",attrs:{"variant":!_vm.isInOrder ? 'light' : 'primary'},on:{"click":_vm.orderButtonClick}},[_c('fa',{staticClass:"shopping-cart",attrs:{"icon":"shopping-cart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }